import React from 'react';
import { motion } from 'framer-motion';

const Awards = () => {
  const awards = [
    {
      year: '2023',
      title: 'Best Residential Club in Nigeria',
      organization: 'Nigerian Club Association',
      description: 'Recognized for outstanding facilities, member services, and community impact.',
      icon: 'fa-trophy'
    },
    {
      year: '2022',
      title: 'Excellence in Member Services',
      organization: 'Hospitality Awards Africa',
      description: 'Awarded for exceptional member experience and customer service standards.',
      icon: 'fa-star'
    },
    {
      year: '2021',
      title: 'Facility of the Year',
      organization: 'Sports & Recreation Council',
      description: 'Honored for world-class sports facilities and maintenance standards.',
      icon: 'fa-medal'
    },
    {
      year: '2020',
      title: 'Community Impact Award',
      organization: 'Rivers State Government',
      description: 'Recognized for contributions to local community development.',
      icon: 'fa-heart'
    },
    {
      year: '2019',
      title: 'Green Club Certification',
      organization: 'Environmental Sustainability Board',
      description: 'Certified for eco-friendly practices and sustainable operations.',
      icon: 'fa-leaf'
    },
    {
      year: '2018',
      title: 'Top 10 Clubs in Africa',
      organization: 'African Club Association',
      description: 'Ranked among the top residential clubs across the continent.',
      icon: 'fa-globe'
    },
    {
      year: '2017',
      title: 'Innovation in Member Engagement',
      organization: 'Club Managers Association',
      description: 'Awarded for digital transformation and member engagement initiatives.',
      icon: 'fa-rocket'
    },
    {
      year: '2015',
      title: 'Best Club in Nigeria',
      organization: 'Nigerian Club Association',
      description: 'First major national recognition for overall excellence.',
      icon: 'fa-crown'
    }
  ];

  const categories = ['All', 'Excellence', 'Community', 'Innovation', 'Sustainability'];
  const [activeCategory, setActiveCategory] = React.useState('All');

  const filteredAwards = activeCategory === 'All' 
    ? awards 
    : awards.filter(award => {
        if (activeCategory === 'Excellence') return award.title.includes('Excellence') || award.title.includes('Best');
        if (activeCategory === 'Community') return award.title.includes('Community');
        if (activeCategory === 'Innovation') return award.title.includes('Innovation');
        if (activeCategory === 'Sustainability') return award.title.includes('Green') || award.title.includes('Sustainability');
        return true;
      });

  return (
    <div className="awards-page">  {/* ← ADD THIS CLASS HERE */}
      {/* Hero Section */}
      <section className="page-hero awards-hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="hero-eyebrow">THE CLUB</span>
            <h1 className="hero-title">Awards & <span className="text-green">Recognition</span></h1>
            <p className="hero-subtitle">Celebrating our commitment to excellence and community</p>
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="awards-stats-section">
        <div className="container">
          <div className="awards-stats-grid">
            <div className="awards-stat-card">
              <span className="stat-number">15+</span>
              <span className="stat-label">Years of Awards</span>
            </div>
            <div className="awards-stat-card">
              <span className="stat-number">25+</span>
              <span className="stat-label">Industry Awards</span>
            </div>
            <div className="awards-stat-card">
              <span className="stat-number">98%</span>
              <span className="stat-label">Member Satisfaction</span>
            </div>
            <div className="awards-stat-card">
              <span className="stat-number">#1</span>
              <span className="stat-label">in Nigeria</span>
            </div>
          </div>
        </div>
      </section>

      {/* Awards Grid */}
      <section className="awards-grid-section">
        <div className="container">
          <div className="section-header">
            <span className="section-eyebrow">OUR ACCOLADES</span>
            <h2 className="section-title">Recognized for <span className="text-green">Excellence</span></h2>
            <p className="section-subtitle">A testament to our unwavering commitment to quality</p>
          </div>

          <div className="awards-filter">
            {categories.map(category => (
              <button 
                key={category}
                className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="awards-grid">
            {filteredAwards.map((award, index) => (
              <motion.div 
                key={index}
                className="award-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="award-icon">
                  <i className={`fas ${award.icon}`}></i>
                </div>
                <div className="award-year">{award.year}</div>
                <h3>{award.title}</h3>
                <p className="award-organization">{award.organization}</p>
                <p className="award-description">{award.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Awards;